﻿
import state from './state';
import Que from './que';
import Responder from './responder';
import {extend} from './functions';
import {default as SimpleEvent, EventTypes} from './event';
import Transformation from './transformation';
import ModelCollection from './modelcollection';
import global from './global';

global.list = [];

class Controller extends Responder{

    constructor(parent, blueprint={}) {

        super();
        this.name = 'DefaultController';

        this.renderOutput = null;
        this.hasChanged = false;
        this.initialized = false;
        this.renderer = null;

        this.parent = parent;
        this.children = [];

        this.attachedEvents = new Map();

        // this.que = new Que();
        this.que = null;
        this.type = 'group';

        this.transformation = null;

        this.blueprint = blueprint;

        this.data = {};

        this.uid = 'ctrl'+Math.round(Math.random()*999999);
        while(global.controllers.has(this.uid)){
            this.uid = 'ctrl'+Math.round(Math.random()*999999);
        }

        this.modelInstances = [];
        this.models = {};
        if(this.blueprint.models){
            
            for(let className in this.blueprint.models){
                let model = this.blueprint.models[className];

                if(! model){    // no value, try to create a new model of className
                    this.models[className] = ModelCollection.getModel(null, className);
                }else if(typeof model == 'string'){
                    // model is a name, try to find the instance or create it
                    this.models[className] = ModelCollection.getModel(model, className);
                }else if(model instanceof Array){
                    // model is an array, try to find the instance or create it and use the settings
                    if(model.length == 3){  // [Class, name, settings]
                        this.models[className] = ModelCollection.getModel(model[1], model[0], model[2]);
                    }else{  // [name, settings]
                        this.models[className] = ModelCollection.getModel(model[0], className, model[1]);
                    }
                }else{
                    this.modelInstances.push(className);
                    // model is an instance, use it
                    this.models[className] = model;
                }
            }
        }


    }

    implementing(publicInterface){

        for(let key of Object.keys(publicInterface)){
            if(! key in this){
                this[key] = cloneObject(publicInterface[key]);
            }
        }
    }
    
    reset(blueprint, renderer=null){

        this.blueprint = this.resetBlueprint(blueprint);
        
        // clear any transformation that were set.
        if(this.transformation != null){
            this.transformation = null;
            // and make sure if we have the same transformation it
            // will again be set.
            if(this.renderOutput && this.renderOutput.calcProps){
                let remove = [];
                for(let key of this.renderOutput.calcProps.keys()){
                    let s = 'transform';
                    if(key == s){
                        remove.push(key);
                    }
                }
                for(let key of remove){
                    this.renderOutput.calcProps.delete(key);
                }
            }
        }

        this.data = {};
        if(this.que){
            this.que.cancelAll();
        }
        this.initialized = false;
        if(! renderer){
            this.update();
        }else{
            // init() will be called in renderer.render()
            this.render(renderer);
        }
    }

    deepNullOutProperties(input){
        if(input && input.constructor && 
                input.constructor === Object && input != null){
            for (let property of Object.keys(input)) {
                // values that are already empty can be removed (no need to null out)
                if(input[property] == null || input[property] == ''){
                    delete input[property];
                }
                input[property] = this.deepNullOutProperties(input[property]);
            }
        }else{
            input = null;
        }
        return input;
    }

    resetBlueprint(newBlueprint){
        let properties = {};
        if(this.blueprint && this.blueprint.properties){
            properties = this.deepNullOutProperties(this.blueprint.properties);
        }
        if(! newBlueprint){
            newBlueprint = {};
        }
        newBlueprint.properties = extend((newBlueprint.properties || {}), properties);
        return newBlueprint;
    }

    setListeners(){
        if(! this.blueprint || ! this.blueprint.listeners){
            return;
        }
        let listeners = this.blueprint.listeners;
        super.setListeners(listeners);
    }

    setResponders(){
        this.removeAllResponders();
        if(! this.blueprint || ! this.blueprint.responders){
            return;
        }
        for(let responder of this.blueprint.responders){
            if(responder instanceof Array){
                responder = {callback: responder};
            }
            let name = responder.name || '*';
            this.addResponder(name, responder.callback);
        }

    }

    // remove the responders that are set through the blueprint,
    // use removeAllResponders() to delete everything
    // removeResponders(){
    //     if(! this.blueprint || ! this.blueprint.responders){
    //         return;
    //     }
    //     for(let responder of this.blueprint.responders){
    //         if(responder instanceof Array){
    //             responder = {callback: responder};
    //         }
    //         let name = responder.name || '*';
    //         this.removeResponder(name, responder.callback);
    //     }
    // }

    getControllerByUid(uid){
        return this.getByUid(uid);
    }
    getByUid(uid){
        return global.controllers.get(uid);
    }

    setTransformation(keys, value){
        // todo: null value should reset the transformation
        if(isNaN(value)){
            return;
        }
        let transform = this.getTransformation();
        if(keys[0] == 'position'){
            if(keys[1] == 'x'){
                transform.setPosition(value, transform.position.y);
            }else if(keys[1] == 'y'){
                transform.setPosition(transform.position.x, value);
            }
        }else if(keys[0] == 'scale'){

            if(keys.length < 2){
                transform.setObjectScale(value);
            }else if(keys[1] == 'x'){
                transform.setObjectScale({x: value, 
                    y: transform.objectScale.get(1,1)});
            }else if(keys[1] == 'y'){
                transform.setObjectScale({x: transform.objectScale.get(0,0),
                        y: value});
            }
        }else if(keys[0] == 'rotation'){
            transform.setRotate(value);
        }
    }

    hasTransformation(){
        if(this.transformation){
            return true; //this.transformation.updateTransformationMatrix;
        }
        return false;
    }

    getTransformation(){
        if(! this.transformation){
            this.transformation = new Transformation();
            this.transformation.setController(this);
        }
        return this.transformation;
    }

    render(renderer){

        this.renderOutput = renderer.render(this, this.blueprint);
            
    }


    init(renderer){
        this.setListeners();
        this.setResponders();
        this.setEvents(renderer);

        // if(this.blueprint.uid){
            if(this.blueprint.uid && this.uid !== this.blueprint.uid){

                global.controllers.delete(this.uid);

                this.uid = this.blueprint.uid;
                if(global.controllers.has(this.uid)){
                    console.warn('Renaming duplicate uid of controller ' + this.uid);
                    let ctrl = global.controllers.get(this.uid);
                    ctrl.uid = 'ctrl' + Math.round(Math.random()*999999);
                    global.controllers.set(ctrl.uid, ctrl);
                }
            }

            global.controllers.set(this.uid, this);
        // }
        this.renderer = renderer;
        this.initialized = true;
        // if(this.hasChanged){
        //     this.hasChanged = false;
        //     this.update();
        // }
    }

    setEvents(renderer){
        
        let node = renderer.getEventBindingElement(this);
        if(! node){
            return;
        }

        let previous = new Map(this.attachedEvents);
        if(this.blueprint.events){
            for(let eventType of Object.keys(this.blueprint.events)){
                let events = this.blueprint.events[eventType];
                if(! (events instanceof Array)){
                    events = [events];
                }
                for(let event of events){
                    let id = eventType + event.toString();
                    if(previous.has(id)){
                        previous.delete(id);
                    }else{
                        this.addEvent(new SimpleEvent(node, EventTypes[eventType], 
                                [this, event, this]), id);                        
                    }
                }
            }
        }

        for(let k of previous.keys()){
            this.removeEvent(k);
        }

    }

    setRenderOutput(output){

        this.renderOutput = output;
    }

    addEvent(event, id=null){

        if(id == null){
            id = Math.floor(99999 * Math.random());
        }
        if(this.attachedEvents.has(id)){
            this.removeEvent(id);
        }
        this.attachedEvents.set(id, event);
        return id;
    }

    removeEvent(event){
        try{
            if(event && event.constructor && event instanceof SimpleEvent){
                for(let [k, e] of this.attachedEvents){
                    if(e === event){
                        this.attachedEvents.delete(k);
                        event.remove();
                        break;
                    }
                }
            }else{
                let e = this.attachedEvents.get(event);
                this.attachedEvents.delete(event);
                e.remove();
            }
        }catch(e){
            console.warn('Error removing event');
        }
    }

    update(){
        if(this.renderer == null){
            this.hasChanged = true;
        }else{
            this.renderer.que.set(this.uid, this);
        }
    }

    updateAll(){
        state.forceGlobalUpdate = true;
    }

    getQue(){
        if(! this.que){
            this.que = new Que();
        }
        return this.que;
    }

    remove(renderer, removeFromParent=true){
        try{

            super.remove();

            while(this.children.length > 0){
                let child = this.children.splice(0,1)[0];
                if(child && typeof child.remove == 'function'){
                    child.remove(renderer, false);
                }
            }


            if(removeFromParent && this.parent && this.parent.children){
                for(let i = 0; i < this.parent.children.length; i++){
                    if(this.parent.children[i] == this){
                        this.parent.children.splice(i, 1);
                    }
                }
            }

            if(this.que){
                this.que.cancelAll();
            }
            delete this.que;

            this.attachedEvents.forEach(function(event, id){
                event.remove();
            });
            delete this.attachedEvents;

            if(this.models){
                for(let key of Object.keys(this.models)){
                    if(this.modelInstances.indexOf(key) == -1){
                        ModelCollection.releaseModel(this.models[key]);
                    }
                }
                delete this.models;
                delete this.modelInstances;
                delete this.modelInstanceKeys;
            }
            
            
            try{
                renderer.detach(this);
            }catch(e){
                console.log('couldn\'t detach');
                console.log(this.renderOutput.result);
                console.log(e);
            }
            //if(this.blueprint.uid){
                if(! this.uid){
                    console.warn('no uid found!');
                }
                if(! global.controllers.has(this.uid)){
                    console.warn('cannot find controller ' + this.uid);
                }
                global.controllers.delete(this.uid);
            //}

            if(this.transformation){
                this.transformation.remove();
            }
            delete this.transformation;
            delete this.renderOutput;
            delete this.parent;
            delete this.children;
            delete this.uid;
            delete this.blueprint;
            delete this.data;
            delete this.renderer;
        }catch(e){
            console.log(this);
            console.warn('Error deleting object: ' + e.message);
        }
    }

}



let Blueprint = {
    type: Controller,
    properties: {},
    events: {  },
    children: []
}

export default Controller;

